import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Merge Tailwind class strings, letting later classes win over earlier ones
 * without specificity fights.
 *
 *   cn('px-4', isWide && 'px-8')   // → 'px-8'
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
